module.exports = "<p>\n  exams-category-edit works!\n</p>\n"